// 菜单管理
import http from "@/jslibs/axios/http";

// 新增菜单
export const add = (data) => http.post("/cms/menu/add", data);

// 编辑菜单
export const edit = (data) => http.post("/cms/menu/update", data);

// 菜单详情
export const detail = (id) => http.get("/cms/menu/details/" + id);

// 菜单全量列表
export const list = () => http.get("/cms/menu/list");

// 菜单分页列表
export const page = (data) => http.get("/cms/menu/page", data);

// 菜单删除
export const del = (id) => http.delete("/cms/menu/" + id);
